<atx-skeleton-basic height="2.5rem"></atx-skeleton-basic>
